// extracted by mini-css-extract-plugin
export default {"container":"ChoicesBody_container__JQQG3","choice":"ChoicesBody_choice__Q7UpU","disabledChoice":"ChoicesBody_disabledChoice__fXRIL"};